export default "__VITE_ASSET__9e78a6a9__"